export default "__VITE_ASSET__FrylnnNr__"